import { useEffect } from 'react';
import { GET_AVAILABLE_WEIGHTS } from '../graphql/Query/Advertise.js';

// Move this component out or define it inside ForeignAir
const WeightOptionsLoader = ({ client, setWeightOptions, values }) => {

    useEffect(() => {
        const fetchAvailableWeights = async () => {
            if (values?.allCountry && values?.itemType) {
                try {
                    const { data } = await client.query({
                        query: GET_AVAILABLE_WEIGHTS,
                        variables: {
                            country: values?.allCountry,
                            itemType: values?.itemType,
                        },
                    });

                    const options = data?.getAvailableWeights?.map(w => ({
                        value: `${w} Kg`,
                        label: `${w} Kg`,
                    }));

                    setWeightOptions(options);
                } catch (err) {
                    console.error("Error fetching weight options:", err);
                    setWeightOptions([]);
                }

            }
        };

        fetchAvailableWeights();
    }, [values?.allCountry, values?.itemType]);

    return null;
};

export default WeightOptionsLoader